import {
  DestroyRef,
  Directive,
  ElementRef,
  Injector,
  Input,
  Signal,
  effect,
  inject,
  runInInjectionContext,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Directive({
  selector: '[sd-value-injector], [wctSdValueInjector]',
  standalone: true,
})
export class SdValueInjectorDirective {
  @Input({ alias: 'sd-value-injector', required: false }) public set source2(
    source: Observable<unknown> | Signal<unknown>
  ) {
    this.source = source;
  }

  @Input({ alias: 'wctSdValueInjector', required: false }) public set source(
    source: Observable<unknown> | Signal<unknown>
  ) {
    if (source instanceof Observable) {
      source.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => this.setValueAttribute(value));
      return;
    }

    runInInjectionContext(this.injector, () => {
      effect(() => {
        this.setValueAttribute(source() ?? '');
      });
    });
  }

  private readonly injector: Injector = inject(Injector);
  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  private setValueAttribute(value: unknown): void {
    this.elementRef.nativeElement.setAttribute('value', `${value}`);
  }
}
